import get from 'lodash.get';
import dateOrderValidation from './dateOrderValidation';

// Check that the date in the input value comes before the date in the specified fieldPath
const isBeforeDateInField = fieldPath => (value, allValues) => {
	const valueInFieldPath = get(allValues, fieldPath);
	return dateOrderValidation(value, valueInFieldPath);
};

export default isBeforeDateInField;
